import Index from "@page-containers/get-care/index";

export default Index;
